import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getIsEditingDisabled = createSelector(
  (state: Store) => state.dealManagement.isEditingDisabled,
  (isEditingDisabled): boolean => isEditingDisabled,
);
